import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';

import { FOOTBALL_PLAY_PRO_ONBOARDING_CLUB_SELECTION } from '@sorare/core/src/constants/__generated__/routes';

import { useFootballEvents } from '@sorare/gameplay/src/lib/events';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  return (
    <Navigate
      to={FOOTBALL_PLAY_PRO_ONBOARDING_CLUB_SELECTION}
      replace
      keepSearchParams
    />
  );
};

export default ProOnboardingPage;
